import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC } from 'react';
import { STYLE_VARS } from '../../../constants/style-vars';
import { Image } from '../../../components/Image';
import { Button } from '../../../components/Button';
import { FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';
import { IPromotion } from '../../../types/promotions.types';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';

interface DinningPromotionItemProps {
  item: IPromotion;
}

const DinningPromotionItem: FC<DinningPromotionItemProps> = ({ item }) => {
  const isDesktop = useIsDesktop();

  return (
    <View
      style={[
        styles.wrapper,
        { flexDirection: isDesktop() ? 'row' : 'column' },
      ]}
    >
      <TouchableOpacity
        onPress={() => {
          NavigationService.push<'DinningPromotionDetail'>(
            'DinningPromotionDetail',
            {
              id: item.id,
            }
          );
        }}
      >
        {item.thumb && (
          <Image
            source={{ uri: item.thumb }}
            style={{
              width: isDesktop() ? 380 : '100%',
              height: 180,
              resizeMode: 'cover',
              marginRight: 20,
              marginBottom: isDesktop() ? 0 : 20,
            }}
          />
        )}
      </TouchableOpacity>
      <View style={{}}>
        <View style={{}}>
          <TouchableOpacity
            onPress={() => {
              NavigationService.push<'DinningPromotionDetail'>(
                'DinningPromotionDetail',
                {
                  id: item.id,
                }
              );
            }}
          >
            <Text style={styles.title}>{item.title}</Text>
          </TouchableOpacity>
        </View>
        <View style={{ paddingVertical: 15 }}>
          <Text style={styles.dayText}>{item.start_date}</Text>
        </View>
        <View style={styles.horizontalLine} />
        <View
          style={{
            alignSelf: 'flex-start',
            marginTop: 15,
            flexDirection: 'row',
            alignItems: 'center',
            gap: 20,
          }}
        >
          <Button
            text="READ MORE"
            style={STYLE_VARS.blueButton}
            onPress={() => {
              NavigationService.push<'DinningPromotionDetail'>(
                'DinningPromotionDetail',
                {
                  id: item.id,
                }
              );
            }}
          />
        </View>
      </View>
    </View>
  );
};

export default DinningPromotionItem;

const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: 20,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 1,
  },
  title: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 20,
    fontWeight: '500',
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  dayText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 15,
    fontWeight: '500',
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
  },
  horizontalLine: {
    width: 30,
    height: 3,
    backgroundColor: STYLE_VARS.primaryColor,
  },
});
